"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaEndDateProperty = exports.ctaEndDatePropertyDefinition = void 0;
exports.ctaEndDatePropertyDefinition = {
    view: { label: 'CTA end date' },
    constraints: [],
    type: 'date-time',
    multiple: false,
    name: 'cta-end-date',
};
const isCtaEndDateProperty = (prop) => {
    return prop.name === exports.ctaEndDatePropertyDefinition.name;
};
exports.isCtaEndDateProperty = isCtaEndDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWVuZC1kYXRlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY3RhLWVuZC1kYXRlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNEJBQTRCLEdBQUc7SUFDMUMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGNBQWMsRUFBRTtJQUMvQixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGNBQWM7Q0FDVyxDQUFBO0FBSTFCLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxJQUFrQixFQUE4QixFQUFFO0lBQ3JGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvQ0FBNEIsQ0FBQyxJQUFJLENBQUE7QUFDeEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQkFBb0Isd0JBRWhDIn0=